import { render, staticRenderFns } from "./ValueToCollect.vue?vue&type=template&id=475286d1&scoped=true&lang=pug&"
import script from "./ValueToCollect.vue?vue&type=script&lang=js&"
export * from "./ValueToCollect.vue?vue&type=script&lang=js&"
import style0 from "./ValueToCollect.vue?vue&type=style&index=0&id=475286d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475286d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VTextField})
